import * as React from 'react';

import PillTag from 'bundles/discussions/components/forumsV2-PillTag';

import _t from 'i18n!nls/discussions';

function getTranslations() {
  return {
    INSTRUCTOR_CREATED: _t('Staff post'),
    STAFF_CREATED: _t('Staff post'),
    INSTRUCTOR_RESPONDED: _t('Staff reply'),
    MENTOR_CREATED: _t('Mentor post'),
    STAFF_RESPONDED: _t('Staff reply'),
    MENTOR_RESPONDED: _t('Mentor reply'),
    HIGHLIGHTED: _t('Highlighted'),
    FORUM_POST_BADGE_MENTOR_RESPONDED: _t('Mentor reply'),
    FORUM_POST_BADGE_STAFF_RESPONDED: _t('Staff reply'),
    FORUM_POST_BADGE_INSTRUCTOR_RESPONDED: _t('Staff reply'),
    FORUM_POST_BADGE_MENTOR_CREATED: _t('Mentor post'),
    FORUM_POST_BADGE_STAFF_CREATED: _t('Staff post'),
    FORUM_POST_BADGE_INSTRUCTOR_CREATED: _t('Staff post'),
    FORUM_POST_BADGE_HIGHLIGHTED: _t('Highlighted'),
    MY_POST: _t('My post'),
    REPLIED: _t('Replied'),
    CLOSED: _t('Closed'),
  };
}

type PropsFromCaller = {
  badge: string;
  className?: string;
};

type PropsToComponent = PropsFromCaller;

const ThreadBadge = (props: PropsToComponent) => {
  const { badge, className } = props;
  const translations = getTranslations();
  let text = '';

  if (badge !== 'HIGHLIGHTED') {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    text = translations[badge];
  }

  if (!text) {
    return null;
  }

  return <PillTag label={text} badge={badge} className={className} />;
};

export default ThreadBadge;
